export const SemboSizeTypes = {
  LARGE: { w: 123, h: 32 },
  MEDIUM: { w: 92, h: 24 },
  SMALL: { w: 61, h: 16 },
};
